function tweakAccordionBlockBorder() {
  const firstListItem = document.querySelector(
    ".pdp-accordion__list-item:first-of-type"
  );

  if (!firstListItem) {
    return;
  }

  firstListItem.addEventListener("click", function (event) {
    event.stopPropagation();

    const selectSizingContents = document.querySelectorAll(
      ".sizing-item .sizing-item__content"
    );

    selectSizingContents.forEach((content) => {
      const nestedAccordionBlock = content.querySelector(
        ".sizing-stack__content-instructions"
      );
      if (nestedAccordionBlock) {
        nestedAccordionBlock.addEventListener("click", function (event) {
          event.stopPropagation();
          content.classList.toggle("active");
        });
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  tweakAccordionBlockBorder();
});
